module.exports = __webpack_public_path__ + "img/fast-worker.845d62f0.png";